// // import { useRef, useEffect } from "react";
// // import Recorder from "recorder-js"; // Make sure you have recorder-js
// // import Config from "../config";

// // const Exam_URL = Config.mediaUrl;
// // const Exam_Websocket_URL = Config.ws_url;

// // export const useRecording = ({
// //   setAudioStream,
// //   setStream,
// //   setIsRecording,
// //   setRecordingStartTime,
// //   setRecordingDuration,
// //   currentQuestion,
// //   setQuestionStatus,
// //   currentVivaQuestionId,
// //   ee_id,
// // }) => {
// //   const recorderRef = useRef(null);
// //   const audioContextRef = useRef(null);
// //   const frameIntervalRef = useRef(null);
// //   const socketRef = useRef(null);

// //    const videoRecorderRef = useRef(null);
// //     const videoChunksRef = useRef([]);
// //   // // ------------------- Send video frame to backend -------------------

// //   useEffect(() => {
// //     const protocol = window.location.protocol === "https:" ? "wss" : "ws";
// //     const host = window.location.host;

// //     // const wsUrl = `${protocol}://${host}/ws/video-analyzer/${ee_id}/`;
// //     const wsUrl = `ws://localhost:8000/ws/video-analyzer/${ee_id}/`;
// //     console.log("🔌 Connecting to:", wsUrl);

// //     socketRef.current = new WebSocket(wsUrl);
// //     socketRef.current.binaryType = "arraybuffer";

// //     socketRef.current.onopen = () => {
// //       console.log("✅ Connected to Video Analyzer WebSocket");
// //     };

// //     socketRef.current.onmessage = (event) => {
// //       if (typeof event.data === "string") {
// //         try {
// //           const data = JSON.parse(event.data);
// //           if (data.status === "frame processed") {
// //             console.log("⚙️ Alerts:", data.alerts);
// //           } else if (data.status === "success") {
// //             console.log("✅ Summary saved:", data.summary);
// //           } else if (data.error) {
// //             console.error("❌ Error:", data.error);
// //           } else {
// //             console.log("📩 Message:", data);
// //           }
// //         } catch (err) {
// //           console.error("Invalid WebSocket message:", event.data);
// //         }
// //       } else {
// //         console.log("📦 Received binary data");
// //       }
// //     };

// //     socketRef.current.onclose = () => {
// //       console.log("❌ WebSocket disconnected");
// //     };

// //     socketRef.current.onerror = (err) => {
// //       console.error("🚨 WebSocket error:", err);
// //     };

// //     // return () => {
// //     //   if (socketRef.current) socketRef.current.close();
// //     // };
// //   }, []);
// //   useEffect(() => {
// //     const handleBeforeUnload = () => {
// //       if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
// //         socketRef.current.close();
// //         console.log("🔌 WebSocket closed on page unload");
// //       }
// //     };

// //     window.addEventListener("beforeunload", handleBeforeUnload);
// //     return () => window.removeEventListener("beforeunload", handleBeforeUnload);
// //   }, []);

// //   // ------------------- Send frame + metadata together -------------------
// //   const sendVideoFrame = async (frameBlob, questionId) => {
// //     if (!socketRef.current || socketRef.current.readyState !== WebSocket.OPEN) {
// //       console.warn("⚠️ WebSocket not connected, skipping frame");
// //       return;
// //     }

// //     // Step 1: Create metadata JSON
// //     const metadata = {
// //       question_id: questionId,
// //       user_id: "1",
// //       save: true,
// //     };

// //     // Step 2: Encode metadata as text
// //     const metadataBlob = new Blob([JSON.stringify(metadata)], {
// //       type: "application/json",
// //     });

// //     // Step 3: Combine metadata and frame into one multipart-like Blob
// //     const combinedBlob = new Blob(
// //       [
// //         metadataBlob,
// //         new Blob(["\n--FRAME--\n"]), // simple separator
// //         frameBlob,
// //       ],
// //       { type: "application/octet-stream" }
// //     );

// //     // Step 4: Send it over WebSocket
// //     socketRef.current.send(combinedBlob);

// //     console.log("📤 Sent frame and metadata via WebSocket:", questionId);
// //   };

// //   // ------------------- Start Recording -------------------
// //   const startRecording = async () => {
// //     try {
// //       const constraints = { audio: true, video: true };
// //       const combinedStream = await navigator.mediaDevices.getUserMedia(constraints);

// //         // 🎥 Video Recording
// //       videoChunksRef.current = [];

// //       videoRecorderRef.current = new MediaRecorder(combinedStream, {
// //         mimeType: "video/webm"
// //       });

// //       videoRecorderRef.current.ondataavailable = (event) => {
// //         if (event.data.size > 0) {
// //           videoChunksRef.current.push(event.data);
// //         }
// //       };

// //       videoRecorderRef.current.start();
// //       console.log("🎥 Video recording started");

// //       const audioTracks = combinedStream.getAudioTracks();
// //       const videoTracks = combinedStream.getVideoTracks();

// //       if (!audioTracks.length || !videoTracks.length) {
// //         throw new Error("No audio or video tracks available");
// //       }

// //       const newAudioStream = new MediaStream(audioTracks);
// //       const newVideoStream = new MediaStream(videoTracks);

// //       setAudioStream(newAudioStream);
// //       setStream(newVideoStream);
// //       setIsRecording(true);
// //       setRecordingStartTime(Date.now());
// //       setRecordingDuration(0);

// //       // setQuestionStatus((prev) => {
// //       //   const newStatus = [...prev];
// //       //   newStatus[currentQuestion] = "recording";
// //       //   return newStatus;
// //       // });
// //       setQuestionStatus((prev = {}) => {
// //         // ensure prev is an object
// //         const base = (prev && typeof prev === "object") ? prev : {};
// //         const key = currentVivaQuestionId ?? currentQuestion;
// //         return {
// //           ...base,
// //           [key]: "recording",
// //         };
// //       });

// //       // 🎤 Audio Recorder setup using Recorder.js (WAV)
// //       audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
// //       recorderRef.current = new Recorder(audioContextRef.current, { numChannels: 1 });
// //       await recorderRef.current.init(newAudioStream);
// //       recorderRef.current.start();

// //       // 🧠 Start sending frames every 1 second
// //       const videoTrack = newVideoStream.getVideoTracks()[0];
// //       const imageCapture = new ImageCapture(videoTrack);

// //       frameIntervalRef.current = setInterval(async () => {
// //         try {
// //           const frame = await imageCapture.grabFrame();
// //           const canvas = document.createElement("canvas");
// //           canvas.width = frame.width;
// //           canvas.height = frame.height;
// //           const ctx = canvas.getContext("2d");
// //           ctx.drawImage(frame, 0, 0);
// //           canvas.toBlob(
// //             (blob) => {
// //               if (blob) sendVideoFrame(blob, currentVivaQuestionId);
// //             },
// //             "image/jpeg",
// //             0.7
// //           );
// //         } catch (err) {
// //           console.warn("⚠️ Frame capture failed:", err);
// //         }
// //       }, 1000);
// //     } catch (error) {
// //       console.error("❌ Failed to start recording:", error);
// //       alert(`Failed to start recording: ${error.message}`);
// //       setIsRecording(false);
// //       setAudioStream(null);
// //       setStream(null);
// //     }
// //   };

// //   // ------------------- Stop Recording -------------------
// //   const stopRecording = async () => {
// //     let audioBlob = null;
// //     let videoBlob = null;

// //     if (recorderRef.current) {
// //       const promise = new Promise((resolve) => {
// //         recorderRef.current.stop().then(({ blob }) => {
// //           resolve(blob.size > 0 ? blob : null);
// //         });
// //       });
// //       audioBlob = await promise;
// //     }

// //      if (videoRecorderRef.current) {
// //       videoBlob = await new Promise((resolve) => {
// //         videoRecorderRef.current.onstop = () => {
// //           const blob = new Blob(
// //             videoChunksRef.current,
// //             { type: "video/webm" }
// //           );

// //           resolve(blob);
// //         };

// //         videoRecorderRef.current.stop();
// //       });
// //     }

// //     // Clear frame interval
// //     if (frameIntervalRef.current) {
// //       clearInterval(frameIntervalRef.current);
// //       frameIntervalRef.current = null;
// //     }

// //     setIsRecording(false);
// //     setRecordingStartTime(null);
// //     setAudioStream(null);
// //     setStream(null);

// //     // // Update question status
// //     // setQuestionStatus((prev) => {
// //     //   const newStatus = [...prev];
// //     //   newStatus[currentQuestion] = "answered";
// //     //   return newStatus;
// //     // });

// //     setQuestionStatus((prev = {}) => {
// //       const base = (prev && typeof prev === "object") ? prev : {};
// //       const key = currentVivaQuestionId ?? currentQuestion;
// //       return {
// //         ...base,
// //         [key]: "answered",
// //       };
// //     });

// //     return { audioBlob,
// //         videoBlob
// //      };
// //   };

// //   // ------------------- Submit All Recordings -------------------
// //   const submitRecordingForQuestion = async (audioBlob,videoBlob, user_id, vivaQuestionId, QuestionDescription, ee_id,questionTranscript) => {
// //     try {
// //       if (!vivaQuestionId) {
// //         console.warn(`No vivaQID found for question id ${vivaQuestionId}`);
// //         return { success: false, error: "Missing vivaQID" };
// //       }

// //       if (!audioBlob) {
// //         console.warn(`No recordings for question ${vivaQuestionId}`);
// //         return { success: false, error: "No recordings" };
// //       }

// //       const formData = new FormData();
// //       formData.append("AudioFile", audioBlob, `audio_${vivaQuestionId}.wav`);
// //       if (videoBlob) {
// //         formData.append(
// //           "VideoFile",
// //           videoBlob,
// //           `video_${vivaQuestionId}.webm`
// //         );
// //       }
// //       formData.append("UserId", user_id);
// //       formData.append("QuestionDescription", QuestionDescription)
// //       formData.append("QuestionId", vivaQuestionId)
// //       formData.append("fixed", "true");
// //       formData.append("ee_id", ee_id)
// //       formData.append("QuestionTranscript", questionTranscript || "");

// //       const response = await fetch(`/viva/questions/`, {
// //         method: "POST",
// //         body: formData,
// //         credentials: "include",
// //       });

// //       const result = await response.json();
// //       if (!response.ok) throw new Error(result.error || "Unknown error");

// //       console.log(`✅ Question ${vivaQuestionId} submitted successfully`, result);
// //       return { success: true };
// //     } catch (error) {
// //       console.error(`❌ Failed to submit question ${vivaQuestionId}:`, error);
// //       return { success: false, error: error.message };
// //     }
// //   };

// //   return { startRecording, stopRecording, submitRecordingForQuestion };
// // };

// import { useRef, useEffect } from "react";
// import Recorder from "recorder-js"; // Make sure you have recorder-js
// import Config from "../config";

// const Exam_URL = Config.mediaUrl;
// const Exam_Websocket_URL = Config.ws_url;

// export const useRecording = ({
//   setAudioStream,
//   setStream,
//   setIsRecording,
//   setRecordingStartTime,
//   setRecordingDuration,
//   currentQuestion,
//   setQuestionStatus,
//   currentVivaQuestionId,
//   ee_id,
// }) => {
//   const recorderRef = useRef(null);
//   const audioContextRef = useRef(null);
//   const frameIntervalRef = useRef(null);
//   const socketRef = useRef(null);

//    const videoRecorderRef = useRef(null);
//     const videoChunksRef = useRef([]);
//   // // ------------------- Send video frame to backend -------------------

//   // useEffect(() => {
//   //   const protocol = window.location.protocol === "https:" ? "wss" : "ws";
//   //   const host = window.location.host;

//   //   // const wsUrl = `${protocol}://${host}/ws/video-analyzer/${ee_id}/`;
//   //   const wsUrl = `ws://localhost:8000/ws/video-analyzer/${ee_id}/`;
//   //   console.log("🔌 Connecting to:", wsUrl);

//   //   socketRef.current = new WebSocket(wsUrl);
//   //   socketRef.current.binaryType = "arraybuffer";

//   //   socketRef.current.onopen = () => {
//   //     console.log("✅ Connected to Video Analyzer WebSocket");
//   //   };

//   //   socketRef.current.onmessage = (event) => {
//   //     if (typeof event.data === "string") {
//   //       try {
//   //         const data = JSON.parse(event.data);
//   //         if (data.status === "frame processed") {
//   //           console.log("⚙️ Alerts:", data.alerts);
//   //         } else if (data.status === "success") {
//   //           console.log("✅ Summary saved:", data.summary);
//   //         } else if (data.error) {
//   //           console.error("❌ Error:", data.error);
//   //         } else {
//   //           console.log("📩 Message:", data);
//   //         }
//   //       } catch (err) {
//   //         console.error("Invalid WebSocket message:", event.data);
//   //       }
//   //     } else {
//   //       console.log("📦 Received binary data");
//   //     }
//   //   };

//   //   socketRef.current.onclose = () => {
//   //     console.log("❌ WebSocket disconnected");
//   //   };

//   //   socketRef.current.onerror = (err) => {
//   //     console.error("🚨 WebSocket error:", err);
//   //   };

//   //   // return () => {
//   //   //   if (socketRef.current) socketRef.current.close();
//   //   // };
//   // }, []);

//   useEffect(() => {
//   if (!ee_id) {
//     console.warn("⚠️ No ee_id, skipping video WebSocket connection");
//     return;
//   }

//   // Close existing connection
//   if (socketRef.current && (socketRef.current.readyState === WebSocket.OPEN || socketRef.current.readyState === WebSocket.CONNECTING)) {
//     socketRef.current.close();
//     socketRef.current = null;
//   }

//   const protocol = window.location.protocol === "https:" ? "wss" : "ws";
//   const host = window.location.host;

//   const wsUrl = `ws://localhost:8000/ws/video-analyzer/${ee_id}/`;
//   console.log("🔌 Connecting to Video Analyzer:", wsUrl);

//   socketRef.current = new WebSocket(wsUrl);
//   socketRef.current.binaryType = "arraybuffer";

//   let isMounted = true;

//   socketRef.current.onopen = () => {
//     if (isMounted) {
//       console.log("✅ Connected to Video Analyzer WebSocket");
//     }
//   };

//   socketRef.current.onmessage = (event) => {
//     if (!isMounted) return;

//     if (typeof event.data === "string") {
//       try {
//         const data = JSON.parse(event.data);
//         if (data.status === "frame processed") {
//           // Only log if there are alerts
//           if (data.alerts && data.alerts.length > 0) {
//             console.log("⚙️ Alerts:", data.alerts);
//           }
//         } else if (data.status === "success") {
//           console.log("✅ Summary saved:", data.summary);
//         } else if (data.error) {
//           console.error("❌ Error:", data.error);
//         } else {
//           // Only log important messages, not every frame response
//           if (data.message && !data.message.includes("frame")) {
//             console.log("📩 Message:", data);
//           }
//         }
//       } catch (err) {
//         console.error("Invalid WebSocket message:", event.data);
//       }
//     }
//     // Don't log binary data to reduce spam
//   };

//   socketRef.current.onclose = (event) => {
//     if (isMounted) {
//       console.log("❌ Video WebSocket disconnected", event.code);
//     }
//   };

//   socketRef.current.onerror = (err) => {
//     console.error("🚨 WebSocket error:", err);
//   };

//   // Cleanup function
//   return () => {
//     isMounted = false;
//     if (socketRef.current) {
//       if (socketRef.current.readyState === WebSocket.OPEN || socketRef.current.readyState === WebSocket.CONNECTING) {
//         socketRef.current.close();
//       }
//       socketRef.current = null;
//     }
//   };
// }, [ee_id]); // Added ee_id as dependency

//   useEffect(() => {
//     const handleBeforeUnload = () => {
//       if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
//         socketRef.current.close();
//         console.log("🔌 WebSocket closed on page unload");
//       }
//     };

//     window.addEventListener("beforeunload", handleBeforeUnload);
//     return () => window.removeEventListener("beforeunload", handleBeforeUnload);
//   }, []);

//   // ------------------- Send frame + metadata together -------------------
//   // const sendVideoFrame = async (frameBlob, questionId) => {
//   //   if (!socketRef.current || socketRef.current.readyState !== WebSocket.OPEN) {
//   //     console.warn("⚠️ WebSocket not connected, skipping frame");
//   //     return;
//   //   }

//   //   // Step 1: Create metadata JSON
//   //   const metadata = {
//   //     question_id: questionId,
//   //     user_id: "1",
//   //     save: true,
//   //   };

//   //   // Step 2: Encode metadata as text
//   //   const metadataBlob = new Blob([JSON.stringify(metadata)], {
//   //     type: "application/json",
//   //   });

//   //   // Step 3: Combine metadata and frame into one multipart-like Blob
//   //   const combinedBlob = new Blob(
//   //     [
//   //       metadataBlob,
//   //       new Blob(["\n--FRAME--\n"]), // simple separator
//   //       frameBlob,
//   //     ],
//   //     { type: "application/octet-stream" }
//   //   );

//   //   // Step 4: Send it over WebSocket
//   //   socketRef.current.send(combinedBlob);

//   //   console.log("📤 Sent frame and metadata via WebSocket:", questionId);
//   // };

//   const sendVideoFrame = async (frameBlob, questionId) => {
//   if (!socketRef.current || socketRef.current.readyState !== WebSocket.OPEN) {
//     // Only log occasionally, not every frame
//     if (Math.random() < 0.01) { // 1% chance
//       console.warn("⚠️ WebSocket not connected, skipping frame");
//     }
//     return;
//   }

//   const metadata = {
//     question_id: questionId,
//     user_id: "1",
//     save: true,
//   };

//   const metadataBlob = new Blob([JSON.stringify(metadata)], {
//     type: "application/json",
//   });

//   const combinedBlob = new Blob(
//     [
//       metadataBlob,
//       new Blob(["\n--FRAME--\n"]),
//       frameBlob,
//     ],
//     { type: "application/octet-stream" }
//   );

//   socketRef.current.send(combinedBlob);

//   // Remove this log or log only every 10th frame
//   // console.log("📤 Sent frame and metadata via WebSocket:", questionId);
// };

//   // ------------------- Start Recording -------------------
//   const startRecording = async () => {
//     try {
//       const constraints = { audio: true, video: true };
//       const combinedStream = await navigator.mediaDevices.getUserMedia(constraints);

//         // 🎥 Video Recording
//       videoChunksRef.current = [];

//       videoRecorderRef.current = new MediaRecorder(combinedStream, {
//         mimeType: "video/webm"
//       });

//       videoRecorderRef.current.ondataavailable = (event) => {
//         if (event.data.size > 0) {
//           videoChunksRef.current.push(event.data);
//         }
//       };

//       videoRecorderRef.current.start();
//       console.log("🎥 Video recording started");

//       const audioTracks = combinedStream.getAudioTracks();
//       const videoTracks = combinedStream.getVideoTracks();

//       if (!audioTracks.length || !videoTracks.length) {
//         throw new Error("No audio or video tracks available");
//       }

//       const newAudioStream = new MediaStream(audioTracks);
//       const newVideoStream = new MediaStream(videoTracks);

//       setAudioStream(newAudioStream);
//       setStream(newVideoStream);
//       setIsRecording(true);
//       setRecordingStartTime(Date.now());
//       setRecordingDuration(0);

//       // setQuestionStatus((prev) => {
//       //   const newStatus = [...prev];
//       //   newStatus[currentQuestion] = "recording";
//       //   return newStatus;
//       // });
//       setQuestionStatus((prev = {}) => {
//         // ensure prev is an object
//         const base = (prev && typeof prev === "object") ? prev : {};
//         const key = currentVivaQuestionId ?? currentQuestion;
//         return {
//           ...base,
//           [key]: "recording",
//         };
//       });

//       // 🎤 Audio Recorder setup using Recorder.js (WAV)
//       audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
//       recorderRef.current = new Recorder(audioContextRef.current, { numChannels: 1 });
//       await recorderRef.current.init(newAudioStream);
//       recorderRef.current.start();

//       // 🧠 Start sending frames every 1 second
//       const videoTrack = newVideoStream.getVideoTracks()[0];
//       const imageCapture = new ImageCapture(videoTrack);

//       frameIntervalRef.current = setInterval(async () => {
//         try {
//           const frame = await imageCapture.grabFrame();
//           const canvas = document.createElement("canvas");
//           canvas.width = frame.width;
//           canvas.height = frame.height;
//           const ctx = canvas.getContext("2d");
//           ctx.drawImage(frame, 0, 0);
//           canvas.toBlob(
//             (blob) => {
//               if (blob) sendVideoFrame(blob, currentVivaQuestionId);
//             },
//             "image/jpeg",
//             0.7
//           );
//         } catch (err) {
//           console.warn("⚠️ Frame capture failed:", err);
//         }
//       }, 1000);
//     } catch (error) {
//       console.error("❌ Failed to start recording:", error);
//       alert(`Failed to start recording: ${error.message}`);
//       setIsRecording(false);
//       setAudioStream(null);
//       setStream(null);
//     }
//   };

//   // ------------------- Stop Recording -------------------
//   const stopRecording = async () => {
//     let audioBlob = null;
//     let videoBlob = null;

//     if (recorderRef.current) {
//       const promise = new Promise((resolve) => {
//         recorderRef.current.stop().then(({ blob }) => {
//           resolve(blob.size > 0 ? blob : null);
//         });
//       });
//       audioBlob = await promise;
//     }

//      if (videoRecorderRef.current) {
//       videoBlob = await new Promise((resolve) => {
//         videoRecorderRef.current.onstop = () => {
//           const blob = new Blob(
//             videoChunksRef.current,
//             { type: "video/webm" }
//           );

//           resolve(blob);
//         };

//         videoRecorderRef.current.stop();
//       });
//     }

//     // Clear frame interval
//     if (frameIntervalRef.current) {
//       clearInterval(frameIntervalRef.current);
//       frameIntervalRef.current = null;
//     }

//     setIsRecording(false);
//     setRecordingStartTime(null);
//     setAudioStream(null);
//     setStream(null);

//     // // Update question status
//     // setQuestionStatus((prev) => {
//     //   const newStatus = [...prev];
//     //   newStatus[currentQuestion] = "answered";
//     //   return newStatus;
//     // });

//     setQuestionStatus((prev = {}) => {
//       const base = (prev && typeof prev === "object") ? prev : {};
//       const key = currentVivaQuestionId ?? currentQuestion;
//       return {
//         ...base,
//         [key]: "answered",
//       };
//     });

//     return { audioBlob,
//         videoBlob
//      };
//   };

//   // ------------------- Submit All Recordings -------------------
//   const submitRecordingForQuestion = async (audioBlob,videoBlob, user_id, vivaQuestionId, QuestionDescription, ee_id,questionTranscript) => {
//     try {
//       if (!vivaQuestionId) {
//         console.warn(`No vivaQID found for question id ${vivaQuestionId}`);
//         return { success: false, error: "Missing vivaQID" };
//       }

//       if (!audioBlob) {
//         console.warn(`No recordings for question ${vivaQuestionId}`);
//         return { success: false, error: "No recordings" };
//       }

//       const formData = new FormData();
//       formData.append("AudioFile", audioBlob, `audio_${vivaQuestionId}.wav`);
//       if (videoBlob) {
//         formData.append(
//           "VideoFile",
//           videoBlob,
//           `video_${vivaQuestionId}.webm`
//         );
//       }
//       formData.append("UserId", user_id);
//       formData.append("QuestionDescription", QuestionDescription)
//       formData.append("QuestionId", vivaQuestionId)
//       formData.append("fixed", "true");
//       formData.append("ee_id", ee_id)
//       formData.append("QuestionTranscript", questionTranscript || "");

//       const response = await fetch(`/viva/questions/`, {
//         method: "POST",
//         body: formData,
//         credentials: "include",
//       });

//       const result = await response.json();
//       if (!response.ok) throw new Error(result.error || "Unknown error");

//       console.log(`✅ Question ${vivaQuestionId} submitted successfully`, result);
//       return { success: true };
//     } catch (error) {
//       console.error(`❌ Failed to submit question ${vivaQuestionId}:`, error);
//       return { success: false, error: error.message };
//     }
//   };

//   return { startRecording, stopRecording, submitRecordingForQuestion };
// };

import { useRef, useEffect } from "react";
import Recorder from "recorder-js"; // Make sure you have recorder-js
import Config from "../config";
import axios from "axios";

const Exam_URL = Config.mediaUrl;
const Exam_Websocket_URL = Config.ws_url;

// ---- Tunable size/quality knobs (this is the whole "shrink payload" strategy) ----
const VIDEO_WIDTH = 640;
const VIDEO_HEIGHT = 360;
const VIDEO_FRAME_RATE = 15;
const VIDEO_BITRATE = 400_000; // ~400kbps, plenty for face/gaze detection
const AUDIO_BITRATE = 64_000;
const AUDIO_SAMPLE_RATE = 16000; // matches librosa.load(sr=16000) server-side, so no quality loss

const pickVideoMimeType = () => {
  const candidates = [
    "video/webm;codecs=vp8,opus",
    "video/webm;codecs=vp9,opus",
    "video/webm;codecs=opus",
    "video/webm",
  ];
  for (const type of candidates) {
    if (window.MediaRecorder && MediaRecorder.isTypeSupported(type)) {
      return type;
    }
  }
  return ""; // let the browser pick
};

// const buildWebSocketUrl = (path) => {
//   const protocol = window.location.protocol === "https:" ? "wss" : "ws";
//   return `${protocol}://${window.location.host}${path}`;
// };

export const useRecording = ({
  setAudioStream,
  setStream,
  setIsRecording,
  setRecordingStartTime,
  setRecordingDuration,
  currentQuestion,
  setQuestionStatus,
  currentVivaQuestionId,
  ee_id,
}) => {
  const recorderRef = useRef(null);
  const audioContextRef = useRef(null);
  const frameIntervalRef = useRef(null);
  const socketRef = useRef(null);

  const videoRecorderRef = useRef(null);
  const videoChunksRef = useRef([]);
  const recordingStartedAtRef = useRef(null);

  // Guards against firing submitRecordingForQuestion twice for the same
  // question (e.g. a timer race + a manual Save click landing together).
  const isSubmittingRef = useRef(false);

  useEffect(() => {
    if (!ee_id) {
      console.warn("⚠️ No ee_id, skipping video WebSocket connection");
      return;
    }

    // Close existing connection
    if (
      socketRef.current &&
      (socketRef.current.readyState === WebSocket.OPEN ||
        socketRef.current.readyState === WebSocket.CONNECTING)
    ) {
      socketRef.current.close();
      socketRef.current = null;
    }

    // const wsUrl = buildWebSocketUrl(`/ws/video-analyzer/${ee_id}/`);
    // console.log("🔌 Connecting to Video Analyzer:", wsUrl);

    const protocol = window.location.protocol === "https:" ? "wss" : "ws";
    const host = window.location.host;

    const wsUrl = `${protocol}://${host}/ws/video-analyzer/${ee_id}/`;
    // const wsUrl = `ws://localhost:8000/ws/video-analyzer/${ee_id}/`;

    socketRef.current = new WebSocket(wsUrl);
    socketRef.current.binaryType = "arraybuffer";

    let isMounted = true;

    socketRef.current.onopen = () => {
      if (isMounted) {
        console.log("✅ Connected to Video Analyzer WebSocket");
      }
    };

    socketRef.current.onmessage = (event) => {
      if (!isMounted) return;

      if (typeof event.data === "string") {
        try {
          const data = JSON.parse(event.data);
          if (data.status === "frame processed") {
            if (data.alerts && data.alerts.length > 0) {
              console.log("⚙️ Alerts:", data.alerts);
            }
          } else if (data.status === "success") {
            console.log("✅ Summary saved:", data.summary);
          } else if (data.error) {
            console.error("❌ Error:", data.error);
          } else {
            if (data.message && !data.message.includes("frame")) {
              console.log("📩 Message:", data);
            }
          }
        } catch (err) {
          console.error("Invalid WebSocket message:", event.data);
        }
      }
    };

    socketRef.current.onclose = (event) => {
      if (isMounted) {
        console.log("❌ Video WebSocket disconnected", event.code);
      }
    };

    socketRef.current.onerror = (err) => {
      console.error("🚨 WebSocket error:", err);
    };

    return () => {
      isMounted = false;
      if (socketRef.current) {
        if (
          socketRef.current.readyState === WebSocket.OPEN ||
          socketRef.current.readyState === WebSocket.CONNECTING
        ) {
          socketRef.current.close();
        }
        socketRef.current = null;
      }
    };
  }, [ee_id]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      if (
        socketRef.current &&
        socketRef.current.readyState === WebSocket.OPEN
      ) {
        socketRef.current.close();
        console.log("🔌 WebSocket closed on page unload");
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  const sendVideoFrame = async (frameBlob, questionId) => {
    if (!socketRef.current || socketRef.current.readyState !== WebSocket.OPEN) {
      if (Math.random() < 0.01) {
        console.warn("⚠️ WebSocket not connected, skipping frame");
      }
      return;
    }

    const metadata = {
      question_id: questionId,
      user_id: "1",
      save: true,
    };

    const metadataBlob = new Blob([JSON.stringify(metadata)], {
      type: "application/json",
    });

    const combinedBlob = new Blob(
      [metadataBlob, new Blob(["\n--FRAME--\n"]), frameBlob],
      { type: "application/octet-stream" },
    );

    socketRef.current.send(combinedBlob);
  };

  // ------------------- Start Recording -------------------
  const startRecording = async () => {
    try {
      isSubmittingRef.current = false;

      // 🔽 Lower-resolution / lower-framerate capture request.
      // Browsers will clamp to the nearest supported mode if the camera
      // can't do exactly this, but most webcams support 640x360.
      const constraints = {
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true,
          channelCount: 1,
        },
        video: {
          width: { ideal: VIDEO_WIDTH },
          height: { ideal: VIDEO_HEIGHT },
          frameRate: { ideal: VIDEO_FRAME_RATE, max: VIDEO_FRAME_RATE },
        },
      };
      const combinedStream =
        await navigator.mediaDevices.getUserMedia(constraints);

      const audioTracks = combinedStream.getAudioTracks();
      const videoTracks = combinedStream.getVideoTracks();

      if (!audioTracks.length || !videoTracks.length) {
        throw new Error("No audio or video tracks available");
      }

      const newAudioStream = new MediaStream(audioTracks);
      // Keep preview video-only, but record video + mic audio in one WebM so
      // the saved video plays back with sound.
      const newVideoStream = new MediaStream(videoTracks);
      const recordedMediaStream = new MediaStream([
        ...videoTracks,
        ...audioTracks,
      ]);

      setAudioStream(newAudioStream);
      setStream(newVideoStream);
      setIsRecording(true);
      recordingStartedAtRef.current = Date.now();
      setRecordingStartTime(recordingStartedAtRef.current);
      setRecordingDuration(0);

      setQuestionStatus((prev = {}) => {
        const base = prev && typeof prev === "object" ? prev : {};
        const key = currentVivaQuestionId ?? currentQuestion;
        return {
          ...base,
          [key]: "recording",
        };
      });

      // 🎥 Video Recording — includes mic audio for playback
      videoChunksRef.current = [];

      const mimeType = pickVideoMimeType();
      const recorderOptions = {
        ...(mimeType ? { mimeType } : {}),
        videoBitsPerSecond: VIDEO_BITRATE,
        audioBitsPerSecond: AUDIO_BITRATE,
      };

      videoRecorderRef.current = new MediaRecorder(
        recordedMediaStream,
        recorderOptions,
      );

      videoRecorderRef.current.ondataavailable = (event) => {
        if (event.data.size > 0) {
          videoChunksRef.current.push(event.data);
        }
      };

      videoRecorderRef.current.start(1000);
      console.log("🎥 Video recording started", recorderOptions);

      // 🎤 Audio Recorder setup using Recorder.js (WAV), captured at 16kHz
      // mono directly — the server resamples to 16kHz anyway, so this is
      // a free ~3x size reduction with zero loss of analysis quality.
      try {
        audioContextRef.current = new (
          window.AudioContext || window.webkitAudioContext
        )({
          sampleRate: AUDIO_SAMPLE_RATE,
        });
      } catch (err) {
        console.warn(
          "⚠️ Browser ignored requested sampleRate, using default:",
          err,
        );
        audioContextRef.current = new (
          window.AudioContext || window.webkitAudioContext
        )();
      }

      recorderRef.current = new Recorder(audioContextRef.current, {
        numChannels: 1,
      });
      await recorderRef.current.init(newAudioStream);
      recorderRef.current.start();

      // 🧠 Start sending frames every 1 second (unchanged)
      const videoTrack = newVideoStream.getVideoTracks()[0];
      const imageCapture = new ImageCapture(videoTrack);

      frameIntervalRef.current = setInterval(async () => {
        try {
          const frame = await imageCapture.grabFrame();
          const canvas = document.createElement("canvas");
          canvas.width = frame.width;
          canvas.height = frame.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(frame, 0, 0);
          canvas.toBlob(
            (blob) => {
              if (blob) sendVideoFrame(blob, currentVivaQuestionId);
            },
            "image/jpeg",
            0.7,
          );
        } catch (err) {
          console.warn("⚠️ Frame capture failed:", err);
        }
      }, 1000);
    } catch (error) {
      console.error("❌ Failed to start recording:", error);
      alert(`Failed to start recording: ${error.message}`);
      setIsRecording(false);
      setAudioStream(null);
      setStream(null);
    }
  };

  // ------------------- Stop Recording -------------------
  const stopRecording = async () => {
    let audioBlob = null;
    let videoBlob = null;

    const elapsed = recordingStartedAtRef.current
      ? Date.now() - recordingStartedAtRef.current
      : 0;
    if (elapsed > 0 && elapsed < 300) {
      await new Promise((resolve) => setTimeout(resolve, 300 - elapsed));
    }

    if (recorderRef.current) {
      try {
        const { blob } = await recorderRef.current.stop();
        audioBlob = blob && blob.size > 0 ? blob : null;
      } catch (error) {
        console.warn("Audio recorder stop failed:", error);
      } finally {
        recorderRef.current = null;
      }
    }

    if (
      videoRecorderRef.current &&
      videoRecorderRef.current.state !== "inactive"
    ) {
      const recorder = videoRecorderRef.current;
      videoBlob = await new Promise((resolve) => {
        const finish = () => {
          const blob = new Blob(videoChunksRef.current, {
            type: recorder.mimeType || "video/webm",
          });
          resolve(blob.size > 0 ? blob : null);
        };

        recorder.addEventListener("stop", finish, { once: true });
        try {
          recorder.requestData();
        } catch (error) {
          console.warn("Video recorder requestData failed:", error);
        }
        recorder.stop();
      });
    }
    videoRecorderRef.current = null;
    recordingStartedAtRef.current = null;

    if (frameIntervalRef.current) {
      clearInterval(frameIntervalRef.current);
      frameIntervalRef.current = null;
    }

    setIsRecording(false);
    setRecordingStartTime(null);
    setAudioStream(null);
    setStream(null);

    setQuestionStatus((prev = {}) => {
      const base = prev && typeof prev === "object" ? prev : {};
      const key = currentVivaQuestionId ?? currentQuestion;
      return {
        ...base,
        [key]: "answered",
      };
    });

    console.log(
      `📦 Recording sizes — audio: ${audioBlob ? (audioBlob.size / 1024 / 1024).toFixed(2) : 0}MB, video: ${
        videoBlob ? (videoBlob.size / 1024 / 1024).toFixed(2) : 0
      }MB`,
    );

    return { audioBlob, videoBlob };
  };

  // ------------------- Submit All Recordings -------------------
  const submitRecordingForQuestion = async (
    audioBlob,
    videoBlob,
    user_id,
    vivaQuestionId,
    QuestionDescription,
    ee_id,
    questionTranscript,
  ) => {
    // Guard: never double-submit the same question (timer race, double
    // click, or a re-render triggering handleSave twice).
    if (isSubmittingRef.current) {
      console.warn(
        `⏭️ Submit already in progress for question ${vivaQuestionId}, skipping duplicate`,
      );
      return { success: true, duplicate: true };
    }

    try {
      if (!vivaQuestionId) {
        console.warn(`No vivaQID found for question id ${vivaQuestionId}`);
        return { success: false, error: "Missing vivaQID" };
      }

      if (!audioBlob) {
        console.warn(`No recordings for question ${vivaQuestionId}`);
        return { success: false, error: "No recordings" };
      }

      isSubmittingRef.current = true;

      const formData = new FormData();
      formData.append("AudioFile", audioBlob, `audio_${vivaQuestionId}.wav`);
      if (videoBlob) {
        formData.append("VideoFile", videoBlob, `video_${vivaQuestionId}.webm`);
      }
      formData.append("UserId", user_id);
      formData.append("QuestionDescription", QuestionDescription);
      formData.append("QuestionId", vivaQuestionId);
      formData.append("fixed", "true");
      formData.append("ee_id", ee_id);
      formData.append("QuestionTranscript", questionTranscript || "");

      const response = await axios.post(`/viva/questions/`, formData, {
        withCredentials: true,
      });

      const result = response.data || {};

      if (response.status < 200 || response.status >= 300) {
        throw new Error(
          result.error || `Server responded with status ${response.status}`,
        );
      }

      console.log(
        `✅ Question ${vivaQuestionId} submitted successfully`,
        result,
      );
      return { success: true };
    } catch (error) {
      console.error(`❌ Failed to submit question ${vivaQuestionId}:`, error);
      return { success: false, error: error.message };
    } finally {
      isSubmittingRef.current = false;
    }
  };

  return {
    startRecording,
    stopRecording,
    submitRecordingForQuestion,
    isSubmittingRef,
  };
};
